export enum TerminalTransactionType {
  BLOCK = 'BLOCK',
  CHARGE = 'CHARGE',
}
